import { useTranslation } from 'react-i18next'
import { Knob } from 'primereact/knob'
import { Chart } from 'primereact/chart'

import TotalNotification from '../../chart-components/TotalNotification/TotalNotification'
import ChartLegend from '../../chart-components/legend/Legend'

const FullnessDoughnut = (props: {
  response: any
  detailTitle: string
  icon: any
  colors: string[]
  labels: string[]
  tabIndex: number
  detailFooter: string
  userInfo: any
}) => {
  const { t } = useTranslation()
  const convertNumberIfNan = (val: any) => {
    if (isNaN(val)) return 0
    return val
  }

  return (
    <div className="d-flex flex-column flex-grow-1">
      <div className="d-flex flex-wrap">
        <div style={{ maxWidth: '150px' }}>
          <TotalNotification
            multiple
            totalNotificationCount={props.response?.doughnutItems?.total || 0}
            detailTitle={props.detailTitle}
            icon={props.icon}
          />
        </div>

        <div style={{ maxWidth: '150px' }}>
          <TotalNotification
            multiple
            totalNotificationCount={props.response?.doughnutItems?.totalCapacity || 0}
            detailTitle={t('dashboard.total-capacity')}
            icon={<i className="pi pi-users" style={{ fontSize: '24px' }} />}
          />
        </div>
      </div>

      <div className="flex-grow-1">
        <div>
          <div className="d-flex align-items-center">
            <Knob
              value={
                props.response?.doughnutItems?.totalPercentage &&
                isFinite(props.response?.doughnutItems?.totalPercentage)
                  ? props.response?.doughnutItems?.totalPercentage
                  : 0
              }
              valueTemplate={'{value}%'}
              strokeWidth={20}
              max={100}
              size={175}
              valueColor={props.colors[0]}
            />
            <p style={{ fontSize: '14px', width: '100px', marginLeft: '10px' }}>
              {t('dashboard.total-occupancy-rates-of-office')}
            </p>
          </div>
        </div>

        {props.tabIndex === 2 && (
          <div>
            <div style={{ display: 'flex' }}>
              <Doughnut colors={props.colors} labels={props.labels} response={props.response} />
              <div style={{ marginTop: '4rem' }}>
                {props.colors.map((val, index) => (
                  <ChartLegend
                    color={props.colors[index]}
                    legend={props.labels[index]}
                    value={{
                      percent: Math.round(
                        convertNumberIfNan(
                          props.response?.doughnutItems?.datasets[index] / props.response?.doughnutItems?.total
                        ) * 100
                      ),
                      number: props.response?.doughnutItems?.datasets[index] || 0,
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="mt-3">
        <p style={{ fontSize: '14px' }}>{props.detailFooter}</p>
      </div>
    </div>
  )
}
const Doughnut = (props: { colors: any; labels: string[]; response: any }) => {
  const chartData = {
    labels: props.labels,
    datasets:
      props.response?.doughnutItems?.datasets?.filter((item: number) => item > 0).length === 0
        ? [
            {
              data: [100],
              backgroundColor: '#cecece',
              hoverBackgroundColor: '#cecece',
            },
          ]
        : [
            {
              data: props.response?.doughnutItems?.datasets,
              backgroundColor: [props.colors[0], props.colors[1]],
              hoverBackgroundColor: [props.colors[0], props.colors[1]],
            },
          ],
  }
  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: props.response?.doughnutItems && props.response?.doughnutItems?.total === 0 ? false : true,
      },
    },
  }
  return (
    <Chart
      type="doughnut"
      data={chartData}
      options={options}
      style={{ position: 'relative', marginTop: '12px', width: '175px' }}
    />
  )
}

export default FullnessDoughnut
